<template>
  <div>
    <div v-if="error" class="error" v-html="error"></div>
    <div v-if="$route.query.message" class="message">
      {{ $route.query.message }}
    </div>

    <div class="loading" v-if="loading">
      <div class="wrapper">
        <span class="spinner"></span>
        <p class="sr-only">Loading...</p>
      </div>
    </div>

    <div v-else-if="page" class="deal-flow-page">
      <header class="deal-flow-page--header">
        <div class="wrapper">
          <div class="deal-flow-page--header--title">
            <h1 v-if="page.acf.hero_title">{{ page.acf.hero_title }}</h1>
            <h1 v-else v-html="page.title.rendered"></h1>
          </div>
        </div>
      </header>

      <div class="wrapper deal-flow-page--content">
        <div class="wp-block-group header-aside">
          <div
            class="wp-block-group__inner-container is-layout-constrained wp-block-group-is-layout-constrained"
          >
            <h2 class="wp-block-heading like-h1">How it Works</h2>
            <div v-html="page.content.rendered"></div>

            <router-link to="/deal-flow/new-investment" class="btn lrg">
              <FontAwesomeIcon :icon="plus" />
              New Investment</router-link
            >
          </div>
        </div>
      </div>

      <div class="wrapper">
        <ul v-if="investments.length" class="deal-flow__list">
          <li
            v-for="investment in investments"
            :key="investment.id"
            class="deal-flow__item"
          >
            <div class="deal-flow__content">
              <h2>{{ investment.title }}</h2>
              <p v-if="investment.acf?.summary">
                {{ investment.acf.summary }}
              </p>

              <dl v-if="investment.acf?.type">
                <dt>Type:</dt>
                <dd>{{ investment.acf.type }}</dd>
              </dl>

              <dl v-if="investment.acf?.raise_amount">
                <dt>Raise Amount:</dt>
                <dd>${{ formatAmount(investment.acf.raise_amount) }}</dd>
              </dl>

              <dl v-if="investment.acf?.minimum_investment">
                <dt>Minimum Investment:</dt>
                <dd>${{ formatAmount(investment.acf.minimum_investment) }}</dd>
              </dl>

              <dl v-if="investment.acf?.target_return">
                <dt>Annualized Target Return:</dt>
                <dd>{{ investment.acf.target_return }}</dd>
              </dl>

              <dl v-if="investment.acf?.industry">
                <dt>Industry:</dt>
                <dd>{{ investment.acf.industry }}</dd>
              </dl>

              <a
                :href="investment.pdf"
                v-if="investment.pdf"
                class="btn ght lrg"
                download
                >Download PDF</a
              >
            </div>

            <div class="deal-flow__meta">
              <dl v-if="investment.acf?.company">
                <dt>Company:</dt>
                <dd>{{ investment.acf.company }}</dd>
              </dl>

              <dl v-if="investment.acf?.company_contact">
                <dt>Name:</dt>
                <dd>{{ investment.acf.company_contact }}</dd>
              </dl>

              <dl v-if="investment.acf?.company_contact_phone">
                <dt>Phone:</dt>
                <dd>
                  <a
                    :href="`tel:+1${investment.acf.company_contact_phone
                      .replace('ext', ',')
                      .replaceAll(/[^0-9,]/g, '')}`"
                    >{{ investment.acf.company_contact_phone }}</a
                  >
                </dd>
              </dl>

              <dl v-if="investment.acf?.company_contact_email">
                <dt>E-mail:</dt>
                <dd>
                  <a
                    class="email-address"
                    :href="`mailto:${investment.acf.company_contact_email}`"
                    >{{ investment.acf.company_contact_email }}</a
                  >
                </dd>
              </dl>

              <dl>
                <dt>Sponsoring Member:</dt>
                <dd>
                  <router-link
                    :to="'/members/' + investment.member.slug"
                    class="member"
                  >
                    <img
                      v-if="
                        investment.member.acf_json &&
                        investment.member.acf_json.member_image
                      "
                      :src="
                        investment.member.acf_json.member_image.sizes.thumbnail
                      "
                    />
                    <div class="image-placeholder" v-else>
                      <span
                        ><FontAwesomeIcon :icon="user" class="user-icon"
                      /></span>
                    </div>
                    <div>
                      <p
                        class="member-name"
                        v-html="investment.member.name"
                      ></p>
                    </div>
                  </router-link>
                </dd>
              </dl>
            </div>
          </li>
        </ul>

        <p v-else>No investments yet.</p>
      </div>
    </div>
  </div>
</template>

<script>
import { faCirclePlus, faUser } from '@fortawesome/free-solid-svg-icons';
export default {
  name: 'DealFlowPage',
  data() {
    return {
      loading: true,
      page: null,
      plus: faCirclePlus,
      user: faUser,
    };
  },
  mounted() {
    this.$store.dispatch('getInvestments');
    this.$store.dispatch('getPage', 'deal-flow').then(() => {
      this.page = this.$store.getters.getPage('deal-flow');
      this.loading = false;
    });
  },
  computed: {
    investments() {
      return this.$store.getters.getInvestments;
    },
    error() {
      return this.$store.getters.getError;
    },
  },
  methods: {
    formatAmount(value) {
      const num = Number(value);
      if (!Number.isFinite(num)) return value;
      return Math.round(num).toLocaleString('en-US');
    },
  },
};
</script>
